import { DOCUMENT_TYPES } from "../constants/document-types";

type MaskConfig = {
  mask: string;
  regex: RegExp;
  expectedDigits: number;
};

type MaskMap = Record<string, MaskConfig>;

const DIGIT_PLACEHOLDER = "0";

const maskMap: MaskMap = {
  [DOCUMENT_TYPES.CNPJ]: {
    mask: "00.000.000/0000-00",
    regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
    expectedDigits: 14,
  },
  [DOCUMENT_TYPES.CPF]: {
    mask: "000.000.000-00",
    regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
    expectedDigits: 11,
  },
  [DOCUMENT_TYPES.CUIT]: {
    mask: "00-00000000-0",
    regex: /^\d{2}-\d{8}-\d$/,
    expectedDigits: 11,
  },
};

const applyMask = (value: string, mask: string): string => {
  if (!value) {
    return "";
  }

  const digits = sanitizeDocument(value);
  let digitIndex = 0;
  let result = "";

  for (let i = 0; i < mask.length; i += 1) {
    const maskChar = mask[i];

    if (maskChar === DIGIT_PLACEHOLDER) {
      if (digitIndex < digits.length) {
        result += digits[digitIndex];
        digitIndex += 1;
      } else {
        break;
      }
    } else if (digitIndex < digits.length) {
      result += maskChar;
    }
  }

  return result;
};

export const getDocumentMask = (type?: string): string | undefined =>
  type ? maskMap[type]?.mask : undefined;

export const sanitizeDocument = (value?: string): string =>
  value ? value.replace(/\D/g, "") : "";

export const formatDocumentByType = (value: string, type?: string): string => {
  if (!type || !maskMap[type]) {
    return sanitizeDocument(value);
  }

  return applyMask(value, maskMap[type].mask);
};

export const validateDocumentByType = (value: string, type?: string): boolean => {
  if (!type || !maskMap[type]) {
    return true;
  }

  const sanitized = sanitizeDocument(value);
  const { regex, expectedDigits } = maskMap[type];

  if (sanitized.length !== expectedDigits) {
    return false;
  }

  return regex.test(applyMask(sanitized, maskMap[type].mask));
};

export const DOCUMENT_MASKS = maskMap;
